// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e9396919","879":"6cc53562"}[chunkId] + ".chunk.js";
};